import React from 'react';

const FourOFour = () => {
    return (
        <div>
            <h1>This is 4O4 pages</h1>
        </div>
    );
};

export default FourOFour;